// extracted by mini-css-extract-plugin
module.exports = {"input":"_3r206","wrapper":"tQ5as","checkbox":"_3kWdh","label":"Gbs_W"};